import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/Container/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/Base/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/templates/UsagePolicy/styles.module.scss");
